module.exports = __webpack_public_path__ + "static/media/6.fcb022e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyebrowes/6.png
// module id = 506
// module chunks = 0